import React from "react";

import { onsiteUpsellTileGraphConfig } from "@intelligems/ig-graphs/graph-configs";
import { AnalyzeTinybirdResourceResponseBodyType } from "@intelligems/ig-types/functions/analytics/analyze-resource-tinybird/analyze-resource-tinybird";
import { UpsellAnalyticsPage } from "@src/features/analytics/pages/UpsellAnalyticsPage";
import { UseQueryResult } from "@tanstack/react-query";

interface OnsiteUpsellAnalyticsPageProps {
  data: UseQueryResult<AnalyzeTinybirdResourceResponseBodyType>[];
  totalExperienceVisitors: number;
  testDuration: number;
  compareVariationId: string;
}

export const OnsiteUpsellAnalyticsPage = (
  props: OnsiteUpsellAnalyticsPageProps
) => (
  <UpsellAnalyticsPage
    {...props}
    tileConfig={onsiteUpsellTileGraphConfig}
    productsSource={"onsite_upsell"}
    metricsSectionTitle={"Onsite Upsell Metrics"}
    productsEmptyMessage={"No onsite upsell offers have been accepted yet."}
  />
);
